<template>
    <div class="mb-8 flex flex-col gap-2">
        <div class="w-full mb-6 text-gray-800 font-sm font-semibold leading-10 flex-shrink-0">
            <label>Corner Settings</label>
        </div>
        <div class="mb-6 flex">
            <div class="w-16  text-xs flex-shrink-0">
                <label>Color</label>
            </div>
            <div class="w-full">
                <div class="flex items-center">
                    <input @change="UpdateCornerCustomColor" :checked="config.corner_custom_color"
                        id="checked-corner_custom_color" type="checkbox" value=""
                        class="w-4 h-4 accent-success bg-gray-100 border-gray-200 rounded ">
                    <label for="checked-corner_custom_color"
                        class="ml-2 text-sm font-medium text-grow"> Custom
                        color</label>
                </div>

                <div class="mt-4" v-if="config.corner_custom_color">
                    <div class="rounded-lg p-0.5 bg-[#7979831a] h-8 flex flex-shrink-0 mb-4">
                        <button type="button"
                            class="flex-grow  flex items-center justify-center cursor-pointer text-[#36374fcc] bg-transparent rounded-lg text-xs overflow-hidden transition-all duration-150 ease-out"
                            @click="setColorCorner" :class="{
                                'font-semibold bg-white': config.cornersSquareOptions.color,
                            }">
                            Solid
                        </button>
                        <button type="button" @click="setGradientCorner"
                            class="flex-grow  flex items-center justify-center cursor-pointer text-[#36374fcc] bg-transparent rounded-lg text-xs overflow-hidden transition-all duration-150 ease-out"
                            :class="{
                                'font-semibold bg-white': config.cornersSquareOptions.gradient,
                            }">
                            Gradient
                        </button>
                    </div>
                    <template v-if="config.cornersSquareOptions.color">
                        <div class="mb-4 flex gap-2">
                            <label class="w-14 flex-shrink-0 text-xs">Picker</label>
                            <div class="flex flex-wrap gap-1">
                                <color-picker v-model:pureColor="config.cornersSquareOptions.color" :format="'hex'"
                                    :disableAlpha="true" :shape="'circle'" :isWidget="false" />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex gap-2 items-center mb-4">
                            <label class="w-14 flex-shrink-0 text-xs">Picker</label>
                            <div class="flex gap-2 items-center" v-if="config.cornersSquareOptions.gradient">
                                <div class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                                    backgroundColor:
                                        config.cornersSquareOptions.gradient.colorStops[0].color,
                                }" @click="$refs.cg_1.click()">
                                    <input type="color" class="opacity-0 overflow-hidden" ref="cg_1" :value="
                                        config.cornersSquareOptions.gradient.colorStops[0].color
                                    " @change="UpdateGradient1" />
                                </div>
                                <ArrowRightIcon size="18" stroke-width="1" />
                                <div class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                                    backgroundColor:
                                        config.cornersSquareOptions.gradient.colorStops[1].color,
                                }" @click="$refs.cg_2.click()">
                                    <input type="color" class="opacity-0 overflow-hidden" :value="
                                        config.cornersSquareOptions.gradient.colorStops[1].color
                                    " ref="cg_2" @change="UpdateGradient2" />
                                </div>
                            </div>
                        </div>
                        <div class="flex gap-2 items-center mb-4">
                            <label class="w-14 flex-shrink-0 text-xs">Type</label>
                            <div class="flex items-center gap-3">
                                <div class="flex items-center">
                                    <input id="gradient_type1x" type="radio" :value="'linear'"
                                        v-model="config.cornersSquareOptions.gradient.type" name="gradient_type"
                                        class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                                    <label for="gradient_type1x"
                                        class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Linear</label>
                                </div>
                                <div class="flex items-center ">
                                    <input id="gradient_type2x" :value="'radial'" type="radio"
                                        v-model="config.cornersSquareOptions.gradient.type" name="gradient_type"
                                        class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                                    <label for="gradient_type2x"
                                        class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Radial</label>
                                </div>
                            </div>
                        </div>
                        <div class="flex gap-2 items-center mb-4"
                            v-if="config.cornersSquareOptions.gradient.type == 'linear'">
                            <label class="w-14 flex-shrink-0 text-xs">Rotation</label>
                            <input type="number" class="h-10 bg-gray-200 rounded-md px-3 outline-none"
                                :value="config.cornersSquareOptions.gradient.rotation" @change="UpdateRotationGradient" />
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div class="mb-6 flex">
            <div class="w-16 text-gray-800 text-xs flex-shrink-0 flex items-center">
                <label>Dots</label>
            </div>
            <div class="w-full">
                <Listbox v-model="config.cornersDotOptions.type">
                    <div class="relative mt-1">
                        <ListboxButton
                            class="relative w-full cursor-default rounded-lg bg-gray-200 h-10 pl-3 pr-10 text-left focus:outline-none ">
                            <span class="block text-sm truncate capitalize">{{ config.cornersDotOptions.type?config.cornersDotOptions.type:'none' }}</span>
                            <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </ListboxButton>
                        <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100"
                            leave-to-class="opacity-0">
                            <ListboxOptions
                                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                <ListboxOption v-slot="{ active, selected }" v-for="dot in corner_dot" :key="dot.value"
                                    :value="dot.value" as="template">
                                    <li :class="[
                                        active ? 'bg-amber-100 text-success' : 'text-gray-900',
                                        'relative cursor-default select-none py-2 pr-4 pl-10',
                                    ]">
                                        <span :class="[
                                            selected ? 'font-medium' : 'font-normal',
                                            'block truncate',
                                        ]">{{ dot.name }}</span>
                                        <span v-if="selected"
                                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-success">
                                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                                        </span>
                                    </li>
                                </ListboxOption>
                            </ListboxOptions>
                        </transition>
                    </div>
                </Listbox>
            </div>
        </div>
        <div class="mb-6 flex">
            <div class="w-16 text-gray-800 text-xs flex-shrink-0  flex items-center">
                <label>Squares</label>
            </div>
            <div class="w-full">
                <Listbox v-model="config.cornersSquareOptions.type">
                    <div class="relative mt-1">
                        <ListboxButton
                            class="relative w-full cursor-default rounded-lg bg-gray-200 h-10 pl-3 pr-10 text-left focus:outline-none ">
                            <span class="block text-sm truncate capitalize">{{ config.cornersSquareOptions.type?config.cornersSquareOptions.type:'none' }}</span>
                            <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </ListboxButton>
                        <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100"
                            leave-to-class="opacity-0">
                            <ListboxOptions
                                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                <ListboxOption v-slot="{ active, selected }" v-for="dot in corner_square" :key="dot.value"
                                    :value="dot.value" as="template">
                                    <li :class="[
                                        active ? 'bg-amber-100 text-success' : 'text-gray-900',
                                        'relative cursor-default select-none py-2 pr-4 pl-10',
                                    ]">
                                        <span :class="[
                                            selected ? 'font-medium' : 'font-normal',
                                            'block truncate',
                                        ]">{{ dot.name }}</span>
                                        <span v-if="selected"
                                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-success">
                                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                                        </span>
                                    </li>
                                </ListboxOption>
                            </ListboxOptions>
                        </transition>
                    </div>
                </Listbox>
            </div>
        </div>
    </div>
</template>
<script>

import { useQrCreateStore } from "~~/stores/qrcreate";
import configMixins from "../config.mixin";
import { PaletteIcon, ArrowRightIcon, CheckIcon, SelectorIcon } from "vue-tabler-icons";
import {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue'
export default {
    components: {
        PaletteIcon, ArrowRightIcon, Listbox, CheckIcon, SelectorIcon,
        ListboxLabel,
        ListboxButton,
        ListboxOptions,
        ListboxOption,
    },
    mixins: [configMixins],
    data() {
        return {
            corner_dot: [{
                value: "",
                image: "",
                name: "None",
            },
            {
                value: "dots",
                image: "",
                name: "Dots",
            },
            {
                value: "square",
                image: "",
                name: "Square",
            },],
            corner_square: [{
                value: "dots",
                image: "",
                name: "Dots",
            },
            {
                value: "square",
                image: "",
                name: "Square",
            },
            {
                value: "extra-rounded",
                image: "",
                name: "Extra Rounded",
            },],

        };
    },
    methods: {
        changeCornerDot(e) {
            this.config.cornersDotOptions.type = e
        },
        changeCornerSquare(e) {
            this.config.cornersSquareOptions.type = e
        },
        UpdateCornerCustomColor(e) {
            useQrCreateStore().setCornerCustomColor({ status: e.target.checked, dispatch: true });
        },

        setColorCorner() {
            var color = this.config.dotsOptions.color;
            if (!color) {
                color = "#000000";
            }
            useQrCreateStore().setColorByKey({
                key: "cornersSquareOptions",
                color: color,
            });
            this.$forceUpdate();
        },
        setGradientCorner() {
            var gradient = this.config.dotsOptions.gradient;
            if (!gradient) {
                gradient = {
                    type: "linear",
                    colorStops: [
                        { offset: 0, color: "#6a1a4c" },
                        { offset: 1, color: "#ed1299" },
                    ],
                    rotation: "0",
                };
            }
            useQrCreateStore().setGradientByKey({
                key: "cornersSquareOptions",
                data: JSON.parse(JSON.stringify(gradient)),
            });
            this.$forceUpdate();
        },
        changeColor({ color }) {
            useQrCreateStore().setColorByKey({
                key: "cornersSquareOptions",
                color: color,
            });
        },
        UpdateGradient1(e) {
            useQrCreateStore().setGradientByKey({
                key: "cornersSquareOptions",
                data: {
                    color1: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateGradient2(e) {
            useQrCreateStore().setGradientByKey({
                key: "cornersSquareOptions",
                data: {
                    color2: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateTypeGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "cornersSquareOptions",
                data: { mode: e.target.value },
            });
            this.$forceUpdate();
        },
        UpdateRotationGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "cornersSquareOptions",
                data: { rotation: e.target.value },
            });
        },
    },
};
</script>
  